import React from "react";
import { Div } from "components/Base";
import SelectOptions from "./SelectOptions";
import LinearProgressWithLabel from "./LinearProgressWithLabel";

import * as R from "ramda";
import { connect } from "react-redux";
import { getFileProgress } from "../../selectors";
import css from "./styles.scss";

import { getters } from "../../model";

const decorate = R.compose(
  connect((state, props) => ({
    value: getFileProgress(state, props),
    viaPortal: getters.viaPortal(state)
  }))
);

const Actions = ({ file, uploadId, value, viaPortal }) => {
  return value < 99 ? (
    <Div
      style={{
        width: viaPortal ? "100%" : "50%"
      }}
    >
      <LinearProgressWithLabel value={value} />
    </Div>
  ) : (
    <Div
      style={{
        display: "flex",
        flexDirection: viaPortal ? "column" : "row",
        justifyContent: viaPortal ? "flex-start" : "space-around",
        width: viaPortal ? "100%" : "50%",
        fontStyle: "normal",
        fontWeight: "600",
        fontSize: "12px",
        lineHeight: "15px"
      }}
      className={css.flex__container}
    >
      <SelectOptions
        selectInfo="type"
        title="Type"
        uploadId={uploadId}
        defaultValue={file.type}
        hide={Boolean(file.version)}
        viaPortal={viaPortal}
      />
      <SelectOptions
        selectInfo="versions"
        title="Version"
        uploadId={uploadId}
        defaultValue={file.version}
        viaPortal={viaPortal}
      />
    </Div>
  );
};

export default decorate(Actions);
